/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'add': {
    width: 14,
    height: 14,
    viewBox: '0 0 14 14',
    data: '<g _fill="none" fill-rule="evenodd"><path pid="0" _stroke="#737476" d="M1 1h12v12H1z"/><path pid="1" _fill="#737476" d="M6.5 10.5v-7h1v7z"/><path pid="2" _fill="#737476" d="M10.5 7.5h-7v-1h7z"/></g>'
  }
})
